<template>
	<div class="modal">
      <div class="overlay" @click="$parent.closeProductModal"></div>
      <div class="wrapper">
        <img class="close" src="../images/close.svg" @click="$parent.closeProductModal" />
        <div class="container">
          <div class="preview">
            <img class="img" :src="$parent.imgDomain + $parent.chosenProoduct.img + '.png'"/>
          </div>
          <div class="text">
            <div class="title small product-name">{{$parent.chosenProoduct.name}}</div>
            <div class="title small status product-status">{{ $t('Product available on all servers') }}</div>
            <div class="price">
              <span class="title small amount">{{$parent.chosenProoduct.price}}</span>
              <span class="title small cur">{{currency}}</span>
              <div
                v-if="alreadyInCart"
                class="button in-cart-btn"
                @click="goToCart"
              >
                {{ $t('IN CART') }} ✓
              </div>
              <div
                v-else
                @click="addToCart"
                :class="['button', { 'disabled': adding }]"
              >
                {{ adding ? $t('ADDING...') : $t('ADD TO CART') }}
              </div>
            </div>
            <transition name="fade">
              <div class="desc error" v-if="error">{{error}}</div>
            </transition>
            <transition name="fade">
              <div class="desc success" v-if="success">{{success}}</div>
            </transition>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import cartService from '@/cart'

export default {
	name: 'ProductModal',
	props: ['currency'],
	data: function() {
		return {
			error: '',
      success: '',
      adding: false,
		}
	},
  computed: {
    alreadyInCart() {
      return cartService.isInCart(this.$parent.chosenProoduct.id)
    }
  },
	methods: {
    async addToCart() {
      if (this.adding) return
      this.adding = true
      this.error = ''
      this.success = ''

      const result = await cartService.addItem(this.$parent.chosenProoduct.id, 1)

      if (result.success) {
        this.success = this.$t('Added to cart!')
        setTimeout(() => {
          this.success = ''
        }, 2000)
      } else {
        if (result.status === 401) {
          this.$parent.openSignInModal()
          this.error = this.$t('Please log in to add items to cart')
        } else {
          this.error = result.message || this.$t('Failed to add to cart')
        }
        setTimeout(() => { this.error = '' }, 3000)
      }

      this.adding = false
    },
    goToCart() {
      this.$parent.closeProductModal()
      this.$router.push('/cart')
    }
	},
}
</script>

<style scoped>
.in-cart-btn {
  background: transparent !important;
  border: 1px solid rgba(46, 204, 113, 0.5) !important;
  color: #2ecc71 !important;
  cursor: pointer;
}

.in-cart-btn:hover {
  background: rgba(46, 204, 113, 0.1) !important;
}

.desc.success {
  color: #2ecc71;
  margin-top: 8px;
}
</style>
